import { TabBar, TabItem } from '@wot/components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTab } from '../../../../hooks/useTab';
import { TutorPlan } from '../../../../interfaces/Plan';
import xhr from '../../../../utils/fetch';
import { PlanCard } from './PlanCard';

export default function TutorPlans() {
  const { tutor_id } = useParams();
  const [plans, setPlans] = useState<TutorPlan[]>([]);
  const { activeTab, onTabChange } = useTab('all');

  useEffect(() => {
    xhr({
      url: `/t/${tutor_id}/plans`,
      method: 'GET'
    }).then((res) => {
      if (res.status === 'OK') {
        setPlans(res.data);
      }
    });
  }, []);

  return (
    <div className="w-full min-h-screen bg-neutralBlue2">
      <div className="w-full h-full flex flex-col bg-white rounded-md">
        <h1 className="text-2xl font-semibold p-4">My Plans</h1>

        <div className="w-full border-b border-black">
          <div className="px-4">
            <TabBar
              value={activeTab}
              indicatorColor="bg-secondary"
              onChange={onTabChange}
              textColor="text-neutralGray1"
            >
              <TabItem label="All Plans" value="all" fontSize={15} />
              <TabItem label="Active" value="active" />
              <TabItem label="Pending" value="pending" />
              <TabItem label="Completed" value="completed" />
              <TabItem label="Cancelled" value="cancelled" />
            </TabBar>
          </div>
        </div>
        <div className="p-6 flex flex-col gap-4 items-center">
          {activeTab === 'all' ? (
            plans.length === 0 ? (
              <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
                <h1 className="text-2xl font-semibold text-center">You don&apos;t have any Plans yet!</h1>
              </div>
            ) : (
              plans.map((plan) => <PlanCard key={plan._id} plan={plan} userId={tutor_id} />)
            )
          ) : plans.filter((plan) => plan.status === activeTab).length === 0 ? (
            <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
              <h1 className="text-2xl font-semibold text-center">{`No ${activeTab} plans yet!`}</h1>
            </div>
          ) : (
            plans
              .filter((plan) => plan.status === activeTab)
              .map((plan) => <PlanCard key={plan._id} plan={plan} userId={tutor_id} />)
          )}
        </div>
      </div>
    </div>
  );
}
